import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getTemplatesRoute = () =>
  buildUrl({
    url: `${baseUrl}/billing-api/templates`,
  });

export const updateTemplateByIdRoute = (params: { id: number }) =>
  buildUrl({
    url: `${baseUrl}/billing-api/templates/${params.id}`,
  });

export const deleteTemplateByIdRoute = (params: { id: number }) =>
  buildUrl({
    url: `${baseUrl}/billing-api/templates/${params.id}`,
  });
